import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { message: String, placement: { type: String, default: "bottom" }, onlyWhenTruncated: { type: Boolean, default: false } }

  connect() {
    if (!this.messageValue || this.messageValue.trim() === '') {
      return;
    }

    this.tooltipWrapper = document.createElement("div")
    this.tooltipWrapper.className = "fixed w-max max-w-[300px] z-50 hidden"
    this.tooltipWrapper.style.visibility = "hidden";

    this.tooltip = document.createElement("div")
    this.tooltip.textContent = this.messageValue
    this.tooltip.className = `
      w-full text-paragraph-s md:text-paragraph-m font-regular text-black-1000 px-10 py-8
      border border-black-100 rounded-10 bg-white shadow-[0_0_28px_theme(colors.black.100)]
      whitespace-pre-line
    `

    this.tooltipWrapper.appendChild(this.tooltip)
    document.body.appendChild(this.tooltipWrapper)

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.element.addEventListener("mouseenter", this.show)
    this.element.addEventListener("mouseleave", this.hide)
    this.element.addEventListener("click", this.hide)
  }

  disconnect() {
    if (!this.tooltipWrapper) return

    this.tooltipWrapper.remove()
    this.element.removeEventListener("mouseenter", this.show)
    this.element.removeEventListener("mouseleave", this.hide)
    this.element.removeEventListener("click", this.hide)
  }

  messageValueChanged(value) {
    if (this.tooltip) {
      this.tooltip.textContent = value;
    }
  }

  show() {
    if (this.onlyWhenTruncatedValue && this.element.scrollWidth <= this.element.offsetWidth) {
      return;
    }

    const rect = this.element.getBoundingClientRect();

    this.tooltipWrapper.style.visibility = "hidden";
    this.tooltipWrapper.classList.remove("hidden");

    // Wait for next frame to ensure tooltip is rendered before measuring
    requestAnimationFrame(() => {
      const wrapperRect = this.tooltipWrapper.getBoundingClientRect();

      let left = rect.left + rect.width / 2 - wrapperRect.width / 2;
      let top;

      if (this.placementValue === "top") {
        top = rect.top - wrapperRect.height - 10;
        if (top < 0) top = rect.bottom + 10;
      } else {
        top = rect.bottom + 10;
        if (top + wrapperRect.height > window.innerHeight) {
          top = rect.top - wrapperRect.height - 10;
        }
      }

      const maxLeft = window.innerWidth - wrapperRect.width - 8;
      left = Math.max(8, Math.min(left, maxLeft));

      this.tooltipWrapper.style.left = `${left}px`;
      this.tooltipWrapper.style.top = `${top}px`;
      this.tooltipWrapper.style.visibility = "visible";
    });
  }

  hide() {
    this.tooltipWrapper.classList.add("hidden")
    this.tooltipWrapper.style.visibility = "hidden"
  }
}
